<template>
  <b-card no-body>
    <b-card-header>
      <b-button 
        v-if="$route.name === 'RelatieEdit'"
        :disabled="servicebusy" 
        class="pull-right" 
        variant="success" 
        @click="save()"
      >
        Opslaan
      </b-button>
      <b-card-title v-if="relatie">
        {{ relatie.Naam }}
      </b-card-title>
    </b-card-header>
    
    <b-card-body>
      <b-alert 
        :show="boodschap !== null" 
        class="my-3" 
        dismissible
      >
        {{ boodschap }}
      </b-alert>
      <b-nav 
        tabs 
        class="mb-3"
      >
        <b-nav-item
          v-for="tab in tabs"
          :key="tab.label"
          :title="tab.label"
          :to="tab.to"
          :active="$route.name == tab.label"
        >
          <i :class="tab.icon" />
          {{ tab.label }}
        </b-nav-item>
      </b-nav>
      <router-view 
        :relatie="relatie" 
        :opties="opties"
        :url="relatieUrl"
        :units="units"
        :trajecten="trajecten"
        :busy="busy"
        @save="save"
      />
    </b-card-body>
  </b-card>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin";
import FontAwesome from '../icons/FontAwesome.vue';
export default {
  name: 'Relatie',
  components: { FontAwesome },
  mixins: [serviceMixin],
  beforeRouteUpdate (to, from, next) {
    if (to.params.id !== from.params.id) this.getRelatie(to.params.id);
    next();
  },
  props: {
    edit: {
      type: Boolean,
      default: false
    },
     id: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      opties: [],
      trajectPresets: false,
      relatie: null,
      units: [],
      busy: false,
      trajecten: [],
      tabs: [
        {
          label: "Dashboard",
          icon: "cui-dashboard",
          to: {
            name: "RelatieDashboard"
          }
        },
        {
          label: "Algemeen",
          icon: "cui-pencil",
          to: {
            name: "RelatieEdit"
          }
        },
        {
          label: "Contactpersonen",
          icon: "fa fa-users",
          to: {
            name: "RelatieContactpersonen"
          }
        },
        // {
        //   label: "Contracten",
        //   icon: "cui-list",
        //   to: {
        //     name: "RelatieContractDocumenten"
        //   }
        // },
        {
          label: "Units",
          icon: "cui-list",
          to: {
            name: "RelatieUnits"
          }
        },
        // {
        //   label: "Facturen",
        //   icon: "cui-list",
        //   to: {
        //     name: "RelatieFacturen",
        //     params: {
        //       jaar: new Date().getUTCFullYear()
        //     }
        //   }
        // },
        // {
        //   label: "Documenten",
        //   icon: "cui-list",
        //   to: {
        //     name: "RelatieDocumenten",
        //   }
        // },
        {
          label: "Import",
          icon: "cui-file",
          to: {
            name: "RelatieImportStatus",
          }
        },
        {
          label: "Herinneringen",
          icon: "cui-list",
          to: {
            name: "RelatieOpenstaandeFacturen"
          }
        },
        {
          label: "API-keys",
          icon: "cui-cog",
          to: {
            name: "RelatieAPIKeys"
          }
        }
      ]
    }

  },
  computed: {
    relatieUrl: function() {
      return `/relaties/${this.id}`
    },
    unitsUrl: function() {
      return `${this.relatieUrl}/units`
    }
  },
  mounted() {
    this.getRelatie(this.id);
    // this.getTrajecten();
  },
  methods: {
    getUnits() {
      var vm = this;
      vm.units = [];
      vm.busy = true;
      this.get(this.unitsUrl)
        .then(function(response) {
          vm.units = response.data.units;
          console.log("Loaded", response.data);
          vm.busy = false;
        })
        .catch(function(error) {
          console.log("Error on Authentication", error);
          vm.buys = false;
        });
    },
    // createTraject( omschrijving, taken ) {
    //   var vm = this
    //   this.post(this.relatieUrl + '/trajecten',{ omschrijving: omschrijving, taken: taken }).then(function(response) {
    //       console.log("Loaded", response.data);
    //       vm.trajecten.push(response.data.traject);
    //     })
    //     .catch(function( error ) {
    //       console.log("Error --" , error);
    //     })
    //     .finally(() => {
    //       vm.trajectPresets = false
    //     });
    // },
    getRelatie(id) {
      console.log(id)
      var vm = this;
      this.get(this.relatieUrl)
        .then(function(response) {
          vm.relatie = response.data.relatie;
          // Backwards compatible: backend stuurt nu 'soortenOnderhoud' (voorheen 'emailadressen')
          vm.opties = response.data.soortenOnderhoud || response.data.emailadressen;
          console.log("Loaded", response.data);
        })
        .catch(function( error ) {
          console.log("Error --" , error);
        })
        .finally(() => {
          // Units worden nu per tab opgehaald (overzicht, dashboard)
        });
    },
    
    save() {
      var vm = this;
      this.servicebusy = true;
      this.boodschap = null;
      this.put(this.relatieUrl, { relatie: vm.relatie })
        .then(function(response) {
          vm.servicebusy = false;
          console.log(response.data);
          // Optimistically reflect the change in the relaties Vuex store
          if (response && response.data && response.data.relatie) {
            vm.$store.dispatch('relaties/relatieUpdated', response.data.relatie);
          }
          vm.boodschap = "Opslaan voltooid";
        }) .catch(function(error) {
        console.log("Error on Authentication");
        vm.boodschap = error;
      });
    }
  }
}
</script>